import type { TFunction } from 'i18next';
import type { GlossarySection } from '../constants/reportMetricGlossary';

const SECTION_TITLE_SEP = ' — ';

/** Localize glossary sections using stable report/section/row ids. */
export function localizeGlossarySections(
  sections: GlossarySection[],
  t: TFunction,
): GlossarySection[] {
  return sections.map((section) => {
    const localizedReport = t(
      `esgReports.glossary.reports.${section.reportKey}`,
      section.sectionTitle.split(SECTION_TITLE_SEP)[0] ?? section.sectionTitle,
    );
    const localizedSubsection = t(
      `esgReports.glossary.sections.${section.sectionKey}.title`,
      section.sectionTitle.split(SECTION_TITLE_SEP)[1] ?? section.sectionTitle,
    );

    return {
      ...section,
      sectionTitle: `${localizedReport}${SECTION_TITLE_SEP}${localizedSubsection}`,
      rows: section.rows.map((row) => ({
        ...row,
        metric: t(`esgReports.glossary.rows.${row.id}.metric`, row.metric),
        meaning: t(`esgReports.glossary.rows.${row.id}.meaning`, row.meaning),
      })),
    };
  });
}

export function localizedGlossaryReportTitle(reportKey: string, t: TFunction): string {
  return t(`esgReports.glossary.reports.${reportKey}`);
}

export function localizedGlossarySectionTitle(sectionKey: string, t: TFunction): string {
  return t(`esgReports.glossary.sections.${sectionKey}.title`);
}
